import TableOrders from "./TableOrders";
export default TableOrders;
export { default as TableOrders } from './TableOrders';